import React from 'react';
import { TIMELINE_EXAMPLE } from '../../../data/exampleReviews';
import { ExampleFrame } from '../../examples/ExampleFrame';
import { cn } from '../../../src/lib/utils';
const TONES = {
  neutral: {
    dot: 'bg-text-tertiary',
    badge: null
  },
  flag: {
    dot: 'bg-[#D92D20]',
    badge: {
      label: 'Delay flagged',
      className: 'bg-[#FDECEC] text-[#B42318]'
    }
  },
  next: {
    dot: 'bg-lime',
    badge: {
      label: 'Follow-up assigned',
      className: 'bg-violet-soft text-lime'
    }
  }
} as const;
export function MilestoneTimeline() {
  return <ExampleFrame title={`Grant monitoring · ${TIMELINE_EXAMPLE.recipient}`} subtitle="Milestone: pilot deployment" caption="Fictional grant recipient and dates." data-id="element-1032" data-mp="hlec91f9frsl">
      <ol className="relative flex flex-col gap-4 pl-6" data-id="element-1033" data-mp="7us0jianzlf6">
        <span aria-hidden="true" className="absolute bottom-2 left-[7px] top-2 w-px bg-hairline" data-id="element-1034" data-mp="7u9vpx9xryvn" />
        {TIMELINE_EXAMPLE.events.map(event => {
        const tone = TONES[event.tone];
        return <li key={event.label} className="relative" data-id="element-1035" data-mp="10h4feryxiu82">
              <span aria-hidden="true" className={cn('absolute -left-6 top-1.5 h-3.5 w-3.5 rounded-full border-2 border-panel', tone.dot)} data-id="element-1036" data-mp="3da7mtmw66q0w" />
              <div className="rounded-xl border border-hairline-soft px-3.5 py-3" data-id="element-1037" data-mp="3iadide5k8wo9">
                <div className="flex flex-wrap items-center justify-between gap-2" data-id="element-1038" data-mp="34gcr15gxubxx">
                  <p className="text-[11px] font-semibold uppercase tracking-[0.08em] text-text-tertiary" data-id="element-1039" data-mp="38h52m5da8sxd">{event.label}</p>
                  <span className="font-mono text-xs text-text-tertiary" data-id="element-1040" data-mp="2uhdl3unk4uem">{event.date}</span>
                </div>
                <p className="mt-1 text-sm text-text-primary" data-id="element-1041" data-mp="2zff1u8xighmx">{event.text}</p>
                {tone.badge ? <span className={cn('mt-2 inline-flex rounded-md px-1.5 py-0.5 text-[11px] font-semibold', tone.badge.className)} data-id="element-1042" data-mp="2pjltz2uqlcbh">{tone.badge.label}</span> : null}
              </div>
            </li>;
      })}
      </ol>
    </ExampleFrame>;
}